<template>
  <div class="tov-form">
    <div class="tov-form__wrapper" v-if="isFormRendered">
      <FirmInput :firm-title="formData.legalPersonInfo.full_name"/>
      <INNInput :firm-info="formData.legalPersonInfo"/>
    </div>
  </div>
</template>

<script>
import INNInput from './INNInput'
import FirmInput from './FirmInput'
import { mapState } from 'vuex'

export default {
  name: 'OtherForm',
  components: { FirmInput, INNInput },
  computed: {
    ...mapState({
      formData: state => state.checkout.formData
    }),
    isFormRendered () {
      return this.formData.legalPersonInfo.hasOwnProperty('status') && this.formData.legalPersonInfo.status === 'success'
    }
  }
}
</script>
